// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"385de427","33":"d0cc71e8","135":"d01ba4d6","342":"fa2f811e","777":"978fe4b0","779":"e750f2e1","875":"b37fad64","999":"bd3da8dd"}[chunkId] + ".chunk.js";
};